import styled from "styled-components";
import { breakpoint } from "@utilities";
import { AppModuleLayout } from "@layouts";

export const Term = () => {
    return (
        <AppModuleLayout>
            <StyledTerm>
                <div className="termWrapper">
                    <div className="termContent">
                        <h2 className="heading">Terms and Conditions</h2>
                        <br />
                        <br />
                        <p className="contentText">
                            Your travel has been booked on the basis of the following terms and
                            conditions. The ticket(s) Uluru Adventure (Alice Springs to Alice
                            Springs) - Adult have been booked on your behalf with various Service
                            Providers. Each Service Provider may have their own terms & conditions
                            applying to your travel. It is important that you read the relevant &
                            corresponding terms and conditions for each of your bookings in order to
                            understand all applicable terms & conditions that may apply to your
                            travel booking. If you require additional information, we recommend that
                            you contact the Service Provider for further clarification.
                        </p>
                        <div className="termSection">
                            <h3 className="subSectionHeading">BOOKING CONFIRMATIONS</h3>
                            <p className="contentText">
                                Your Responsibilities:
                                <br />
                                Open tickets:You must book your travel dates in advance with the
                                individual Service Provider as per details provided on your voucher.
                                <br />
                                Tickets with confirmed dates:It is your responsibility to ensure you
                                redeem your tickets on the dates booked. If you wish to change these
                                dates, you must organize it with the Service Provider directly, with
                                adequate notice.
                            </p>
                        </div>
                        <div className="termSection">
                            <h3 className="subSectionHeading">CANCELLATIONS and REFUNDS</h3>
                            <p className="contentText">
                                If you need to cancel or change your trip for any reason, we will
                                charge a fee of 10% of the price in addition to any fees charged by
                                the Service Provider. The remainder will be reimbursed to the same
                                card you made the original purchase with. It is possible your
                                cancellation fees could be up to 100% of the cost of the booking,
                                regardless of whether travel has commenced (for example,
                                cancellations made within 24hrs of travel or certain flight
                                bookings).
                                <br />
                                If a tour or other travel service is cancelled by the Service
                                Provider, we will refund you the amount paid for the tour or other
                                travel service.
                                <br />
                                Flight & bus bookings will, in many cases, incur a 100% cancellation
                                fee.
                                <br />
                                Where a refund or other payment applies, you may choose to transfer
                                the whole cost of the tour (less any operator cancellation charges)
                                to another tour. Whilst we normally attempt to process refunds
                                swiftly, situations (such as natural disasters) may result in
                                approximately 30 days processing time, due to high volume.
                            </p>
                        </div>
                        <div className="termSection">
                            <h3 className="subSectionHeading">TRAVEL INSURANCE</h3>
                            <p className="contentText">
                                We endorse the recommendation of the Department of Foreign Affairs
                                and Trade that all travelers take out travel insurance. It is your
                                personal responsibility to purchase your own travel insurance to
                                cover any liability which may be incurred to us or a Service
                                Provider and other travel misadventures that you wish to be insured
                                against.
                            </p>
                        </div>

                        <div className="termSection">
                            <h3 className="subSectionHeading">SERVICE PROVIDERS</h3>
                            <p className="contentText">
                                We endeavor to package tours that will meet your expectations.
                                However, we take no responsibility for any matters that arise with
                                regard to or during individual tours or arrangements with individual
                                Service Providers.
                                <br />
                                We appreciate your feedback, whether complaints, compliments, or
                                suggestions. However, to the extent permitted by law, we will not be
                                responsible to you for any loss, expense, or damage that you may
                                suffer during any particular tour, accommodation, or travel, no
                                matter the cause. These matters are the responsibility of each
                                individual Service Provider, and you agree that you will not hold us
                                liable in any such circumstance.
                            </p>
                        </div>
                        <div className="termSection">
                            <h3 className="subSectionHeading">PRICES</h3>
                            <p className="contentText">
                                We endeavor to package the best value tours available at the best
                                prices. However, we take no responsibility for price fluctuations
                                arising from changes in the prices charged by Service Providers
                                occurring before final payment. Accordingly, the price of your
                                travel is subject to change until such time as you pay for the
                                travel in full.
                            </p>
                        </div>
                        <div className="termSection">
                            <h3 className="subSectionHeading">EXTRA COSTS</h3>
                            <p className="contentText">
                                Many tours have extra costs, and you should be aware that there may
                                be added expenses. These expenses will differ for each Service
                                Provider but some of the more usual extras are EMC Tax, Stinger Suit
                                Hire, Luggage Storage, Sleeping Bag Hire, Linen Hire, National Park
                                Fee, Food, Insurance, Accommodation, Equipment Hire, Petrol Levy.
                                <br />
                                We will alert you to extra costs to the extent reasonably
                                practicable. However, you must also check with each individual
                                Service Provider when you confirm your ticket.
                            </p>
                        </div>
                        <div className="termSection">
                            <h3 className="subSectionHeading">PASSPORT & VISAS</h3>
                            <p className="contentText">
                                It is your responsibility to ensure that you have valid passports,
                                visas, and re-entry permits which meet the requirements of
                                immigration and other government authorities. Any fines, penalties,
                                payments, or expenditures incurred as a result of such documents not
                                meeting the requirements of those authorities will be your sole
                                responsibility. All travelers must have a valid passport for
                                international travel, and many countries require at least 6 months
                                validity from the date of return, and some countries require a
                                machine-readable passport. Transfers between tours may incur a $30
                                administration fee.
                            </p>
                        </div>
                    </div>
                </div>
            </StyledTerm>
        </AppModuleLayout>
    );
};

const StyledTerm = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    height: calc(100vh - 164px);
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    background: #fff;

    .termWrapper {
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow: auto;
        max-width: 1200px;
        width: 100%;
        padding: 0px 24px;
        padding-bottom: 50px;
    }
    .termSection {
        margin-top: 20px;
    }

    .termContent {
        width: 100%;
        max-width: 1200px;
    }

    .heading {
        font-size: 24px;
        font-weight: 600;
        line-height: 120%;
        color: ${(props) => props.theme.colors.black};
        margin: 0;
        text-align: left;
    }

    .subSectionHeading {
        font-size: 18px;
        font-weight: 600;
        line-height: 120%;
        color: #131214;
        margin: 16px 0 8px 0;
    }

    .contentText {
        margin: 0 0 16px 0;
    }

    ${breakpoint.breakMobileMedium`
        .termContent {
            padding: 24px;
            font-size: 16px;
            font-weight: 400;

            &::-webkit-scrollbar {
                width: 5px;
            }

            &::-webkit-scrollbar-thumb {
                background-color: rgba(0, 0, 0, .3);
                border-radius: 5px;
            }
        }
    `}

    @media (max-width: ${(p) => p.theme.breakPoints.breakMobile}) {
        .heading {
            font-size: 24px;
        }
        .subHeading,
        .termContent,
        .subSectionHeading {
            font-size: 16px;
        }
    }
`;
